import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface WorkspaceSectionProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function WorkspaceSection({
  title,
  description,
  action,
  className,
  children,
}: WorkspaceSectionProps) {
  const hasHeaderRow = description !== undefined || action !== undefined;

  return (
    <section aria-label={title} className={className}>
      {hasHeaderRow ? (
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h2 className="text-base font-medium leading-tight tracking-tight">{title}</h2>
            {description !== undefined ? (
              <p className="mt-1 text-xs text-muted-foreground">{description}</p>
            ) : null}
          </div>
          {action !== undefined ? <div className="shrink-0">{action}</div> : null}
        </div>
      ) : (
        <h2 className="text-base font-medium leading-tight tracking-tight">{title}</h2>
      )}
      <div className={cn('mt-3')}>{children}</div>
    </section>
  );
}
